
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","opacity":".01","d":"M0 0h16v16H0z"}}),_c('path',{attrs:{"d":"M6.573 12a.667.667 0 01-.486-.213L2.847 8.34a.667.667 0 11.973-.913l2.747 2.926 5.606-6.133a.667.667 0 11.987.893L7.067 11.78a.667.667 0 01-.487.22h-.007z"}})])
          )
        }
      }
    